import { useEffect, useState } from 'react'
import { supabase } from '@/lib/supabase'
import { useOrg } from '@/context/OrgContext'
import type { Category } from '@/types'

export function useCategories() {
  const { orgId, loading: orgLoading } = useOrg()
  const [categories, setCategories] = useState<Category[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (orgLoading) return

    async function fetch() {
      if (orgId) {
        // Fetch hanya kategori yang di-assign ke org ini
        const { data } = await supabase
          .from('organization_categories')
          .select('category_id, categories(*)')
          .eq('organization_id', orgId)
          .order('category_id')

        const cats = (data ?? [])
          .map((row: any) => row.categories)
          .filter(Boolean)
          .sort((a: Category, b: Category) => (a.urutan ?? 0) - (b.urutan ?? 0))

        setCategories(cats)
      } else {
        // Tidak ada org → tampil semua (dev mode)
        const { data } = await supabase
          .from('categories')
          .select('*')
          .order('urutan')
        setCategories(data ?? [])
      }
      setLoading(false)
    }

    fetch()
  }, [orgId, orgLoading])

  return { categories, loading }
}
